import { ActionCenterTypes } from '@/core/interfaces/common';

import {
  TypeButtonsWrapper,
  TypeRadio,
} from './PickActionType.styles';

interface PickActionTypeProps {
  actionCenterType: ActionCenterTypes;
  backgroundColor: string;
  className?: string;
  setActionCenterType: React.Dispatch<React.SetStateAction<ActionCenterTypes>>;
  textColor: string;
}

export const PickActionType = ({
  actionCenterType,
  backgroundColor,
  className,
  setActionCenterType,
  textColor,
}: PickActionTypeProps) => {
  const {
    emailType,
    phoneType,
  } = ActionCenterTypes;

  return (
    <TypeButtonsWrapper
      backgroundcolor={backgroundColor}
      className={className}
    >
      <TypeRadio
        backgroundcolor={backgroundColor}
        textcolor={textColor}
        checked={actionCenterType === emailType}
        htmlFor="radioEmail"
      >
        Email
        <input
          checked={actionCenterType === emailType}
          id="radioEmail"
          name="radioActionCenterType"
          onChange={() => setActionCenterType(emailType)}
          type="radio"
          value="email"
        />
      </TypeRadio>
      <TypeRadio
        backgroundcolor={backgroundColor}
        textcolor={textColor}
        checked={actionCenterType === phoneType}
        htmlFor="radioPhone"
      >
        Phone
        <input
          checked={actionCenterType === phoneType}
          id="radioPhone"
          name="radioActionCenterType"
          onChange={() => setActionCenterType(phoneType)}
          type="radio"
          value="phone"
        />
      </TypeRadio>
    </TypeButtonsWrapper>
  );
};

PickActionType.defaultProps = {
  className: '',
};
